import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "@/components/feature/ArticleLayout";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
const articlePath = "/artykul/prywatnosc-usfansspreadsheet";
const articleTitle = "Prywatność i ochrona danych w USFansSpreadsheet";
const articleDesc = "Szczegółowa analiza polityki prywatności USFansSpreadsheet. Dowiedz się, jak platforma chroni Twoje dane osobowe i jakie masz prawa jako użytkownik.";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": articleTitle,
  "description": articleDesc,
  "author": { "@type": "Person", "name": "Anna Kowalska", "jobTitle": "Specjalista SEO" },
  "datePublished": "2026-06-09",
  "dateModified": "2026-06-24",
  "publisher": { "@type": "Organization", "name": "USFansSpreadsheet.help", "url": siteUrl },
  "mainEntityOfPage": { "@type": "WebPage", "@id": `${siteUrl}${articlePath}` },
  "inLanguage": "pl-PL"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Strona główna", "item": siteUrl },
    { "@type": "ListItem", "position": 2, "name": "Artykuły", "item": `${siteUrl}/artykul/przewodnik-usfansspreadsheet` },
    { "@type": "ListItem", "position": 3, "name": "Prywatność" }
  ]
};

const relatedArticles = [
  { title: "Czy USFansSpreadsheet jest bezpieczny?", to: "/artykul/bezpieczenstwo-usfansspreadsheet" },
  { title: "Kompletny przewodnik po USFansSpreadsheet", to: "/artykul/przewodnik-usfansspreadsheet" },
  { title: "USFansSpreadsheet opinie 2026", to: "/artykul/opinia-usfansspreadsheet" },
];

export default function ArticlePrivacy() {
  return (
    <>
      <PageMeta
        title={articleTitle}
        description={articleDesc}
        keywords="USFansSpreadsheet, prywatność, ochrona danych, RODO, polityka prywatności, bezpieczeństwo, Polska"
        canonicalPath={articlePath}
        ogType="article"
      />
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />

      <Navbar />
      <ArticleLayout title="Prywatność i ochrona danych w USFansSpreadsheet" category="Prywatność" heroImg="https://readdy.ai/api/search-image?query=Privacy%20concept%20with%20a%20modern%20laptop%20screen%20showing%20a%20lock%20icon%20over%20document%20interface%2C%20clean%20cream%20desk%20with%20subtle%20warm%20shadows%2C%20soft%20diffused%20lighting%2C%20trustworthy%20secure%20atmosphere%2C%20professional%20editorial%20photography&width=1400&height=600&seq=art-priv-hero-v2&orientation=landscape" heroImgAlt="Prywatność USFansSpreadsheet" relatedArticles={relatedArticles}>
        <p className="text-lg md:text-xl text-foreground-800 font-medium leading-relaxed">Ochrona prywatności jest jednym z filarów <strong>USFansSpreadsheet</strong>. Platforma stosuje rygorystyczne standardy, aby zapewnić pełną kontrolę nad danymi użytkowników.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Polityka prywatności</h2>
        <p><strong>USFansSpreadsheet</strong> gromadzi tylko niezbędne dane, które są wymagane do prawidłowego działania platformy. Wszystkie informacje są przetwarzane zgodnie z europejskimi standardami RODO, a użytkownicy mają pełną kontrolę nad tym, jakie dane są przechowywane.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Kontrola użytkownika nad danymi</h2>
        <p>Każdy użytkownik <strong>USFansSpreadsheet</strong> ma dostęp do panelu zarządzania prywatnością, gdzie może przeglądać, modyfikować i usuwać swoje dane. Platforma nie udostępnia informacji użytkowników stronom trzecim bez wyraźnej zgody.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Bezpieczne przechowywanie</h2>
        <p>Wszystkie dane w <strong>USFansSpreadsheet</strong> są przechowywane na serwerach zlokalizowanych w Unii Europejskiej, co zapewnia zgodność z najsurowszymi regulacjami dotyczącymi ochrony danych osobowych.</p>
      </ArticleLayout>
      <Footer />
    </>
  );
}